import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../ts/Glob';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import GlobalState from '../../../../_common/platform/ts/globalStates/GlobalState';
import * as FilterUtilities from '../../../../_common/platform/tsx/filtering/FilterUtilities';
import { WorkspaceLayoutType } from '../../ts/Interfaces';
import { LayoutCarouselNavigation } from '../LayoutCarousel';
import WorkspaceTabMenu from './WorkspaceTabMenu';
import * as permissions from '../../../../_common/platform/ts/permissions';
import { IWorkspaceState } from '../Workspace';
import { ITab } from '../../ts/stores/AppStore';
import WorkspacesNavigation from './WorkspacesNavigation';
import { MenuModes } from './Common';
import { themeVars } from '../../ts/themes/themeConstants';
import * as Globalization from '../../../../_common/platform/ts/Globalization';

export type ShowMode = 'icon' | 'text' | 'iconAndText';

export default function ToolbarButtons(props: {
    theme: IValuesCollection;
    buttonClass?: string;
    globalState?: GlobalState;
    options: {
        workspace?: number;
        tab?: number;
    };
    glob: IGlob;

    justifyButtons?: boolean;
    showAddTabButton: boolean;
    forNavigationBar?: boolean;

    hideResetButton?: boolean;
    hideRefreshButton?: boolean;
    hideApplyButton?: boolean;

    resetButtonShowMode?: ShowMode;
    refreshButtonShowMode?: ShowMode;
    showBackButton?: boolean;
    backButtonShowMode?: ShowMode;
    showFullScreenButton?: boolean;
    fullScreenButtonShowMode?: ShowMode;

    onAddTabClick?(): void;
    onResetClick?(): void;
    onApplyClick?(): void;
    onRefreshClick?(): void;
}) {
    const [storeState, setStoreState] = React.useState({ ...props.glob.ToolbarButtonsStore.getState() });

    React.useEffect(() => {
        const handleOnStoreChange = () => {
            setStoreState({ ...props.glob.ToolbarButtonsStore.getState() });
        };

        props.glob.ToolbarButtonsStore.addChangeListener(handleOnStoreChange);

        return () => {
            props.glob.ToolbarButtonsStore.removeChangeListener(handleOnStoreChange);
        };
    }, []);

    const handleOnRefreshButtonClick = () => {
        if (storeState.cancelIsOn) {
            props.glob.AQLQueries.cancelQueries();
        } else {
            if (props.onRefreshClick != null) {
                props.onRefreshClick();
            } else if (props.options != null) {
                props.glob.AppActions.workspaceUpdateInitiate(false, props.options.workspace, props.options.tab);
            }
        }
    };

    const handleOnApplySwitcherClick = (e) => {
        e.stopPropagation();
        //e.preventDefault();

        const applySwitcherState = FilterUtilities.getApplySwitcherState(props.theme);
        // Value is not to be saved in state when it equal to default one.
        const onByDefault = applySwitcherState === FilterUtilities.ApplySwitcherStates.ON_BY_DEFAULT;
        const checked = e.target.checked;

        let value = checked;

        if (value === onByDefault) {
            value = null;
        }

        const tab = props.options?.tab;

        if (tab != null) {
            props.glob.AppActions.toolbarBottons_SwitchApply(tab, value);
        }

        if (checked && props.onApplyClick) {
            props.onApplyClick();
        }
    };

    const tab = props.options?.tab;
    const locale = Globalization.getWidgetLocale(props.theme);

    let navigationBarButtonsStyle: React.CSSProperties;
    let buttonClass = props.buttonClass != null ? ' ' + props.buttonClass : '';

    if (props.forNavigationBar) {
        navigationBarButtonsStyle = {
            color: props.theme['navbar-foreground'],
            backgroundColor: props.theme['navbar-background']
        };

        if (props.theme['navbar-has-shadow'] === true) {
            navigationBarButtonsStyle.boxShadow = '.3rem .3rem 1.5rem rgba(0,0,0,0.4)';
        }
    } else {
        buttonClass += ' btn-middle';
    }

    let addTabButton: React.JSX.Element;

    if (props.showAddTabButton) {
        addTabButton = (
            <button
                type="button"
                className={'add-tab-button btn JEST-toolbar-button-new-tab' + buttonClass}
                title={'Add Tab'}
                style={navigationBarButtonsStyle}
                onClick={props.onAddTabClick}
            >
                <span className="glyphicon glyphicon-plus"></span>
            </button>
        );
    }

    let resetButton: React.JSX.Element;

    if (props.hideResetButton !== true) {
        const resetButtonTitle = Globalization.getMessage('resetFiltersButtonTitle', locale);
        const resetButtonTooltip = Globalization.getMessage('resetFiltersButtonTooltip', locale);

        let resetButtonContent: React.JSX.Element;
        let resetButtonMode: string;

        switch (props.resetButtonShowMode) {
            case 'text':
                resetButtonMode = ' text-mode';
                resetButtonContent = <span>{resetButtonTitle}</span>;
                break;

            case 'iconAndText':
                resetButtonMode = ' icon-and-text-mode';
                resetButtonContent = (
                    <React.Fragment>
                        <span className="glyphicon glyphicon-remove-circle" />
                        <span>{resetButtonTitle}</span>
                    </React.Fragment>
                );
                break;

            default:
                resetButtonMode = ' icon-mode';
                resetButtonContent = <span className="glyphicon glyphicon-remove-circle" />;
        }

        resetButton = (
            <button
                type="button"
                className={
                    'reset-button btn JEST-test-button-reset' +
                    (props.forNavigationBar ? '' : ' btn-default') +
                    resetButtonMode +
                    buttonClass
                }
                title={resetButtonTooltip}
                style={navigationBarButtonsStyle}
                onClick={props.onResetClick}
            >
                {resetButtonContent}
            </button>
        );
    }

    let applyButton: React.JSX.Element;

    if (props.hideApplyButton !== true) {
        let applyIsOn = false;
        let globalState = props.globalState;

        if (globalState == null) {
            const tab = props.options?.tab;

            if (tab != null) {
                globalState = GlobalState.getGlobalState(props.glob, tab);
            }
        }

        if (globalState != null) {
            applyIsOn = globalState.notAppliedFiltersExist();
        }

        let applySwitcher: React.JSX.Element;

        const applySwitcherState = FilterUtilities.getApplySwitcherState(props.theme);

        if (applySwitcherState !== FilterUtilities.ApplySwitcherStates.HIDDEN) {
            let switcherIsOn = tab != null && storeState.applySwitchers[tab];

            if (switcherIsOn == null) {
                switcherIsOn = applySwitcherState === FilterUtilities.ApplySwitcherStates.ON_BY_DEFAULT;
            }

            applySwitcher = (
                <input
                    type="checkbox"
                    className="apply-checkbox"
                    checked={switcherIsOn}
                    onClick={handleOnApplySwitcherClick}
                    onChange={() => {}}
                ></input>
            );
        }

        let applyButtonStyle: React.CSSProperties;

        if (applyIsOn) {
            applyButtonStyle = { ...navigationBarButtonsStyle };
            delete applyButtonStyle.color;
            delete applyButtonStyle.backgroundColor;
        } else {
            applyButtonStyle = navigationBarButtonsStyle;
        }

        const applyButtonTitle = Globalization.getMessage('applyButtonTitle', locale);
        const applyButtonTooltip = Globalization.getMessage('applyButtonTooltip', locale);

        applyButton = (
            <button
                type="button"
                className={
                    'apply-button btn JEST-toolbar-button-apply' +
                    (props.globalState != null ? ' wide' : '') + // At the top Toolbar is should not be wide.
                    (applyIsOn ? ' btn-success' : ' btn-default') +
                    buttonClass
                }
                style={applyButtonStyle}
                onClick={props.onApplyClick}
            >
                {applySwitcher}
                <span title={applyButtonTooltip}>{applyButtonTitle}</span>
            </button>
        );
    }

    let refreshButton: React.JSX.Element;

    if (props.hideRefreshButton !== true) {
        const refreshButtonTitle = Globalization.getMessage('refreshButtonTitle', locale);
        const refreshButtonTooltip = Globalization.getMessage('refreshButtonTooltip', locale);
        const cancelButtonTitle = Globalization.getMessage('refreshButtonCancelTitle', locale);
        const cancelButtonTooltip = Globalization.getMessage('refreshButtonCancelTooltip', locale);

        let refreshButtonContent: React.JSX.Element;
        let refreshButtonMode: string;

        switch (props.refreshButtonShowMode) {
            case 'text':
                refreshButtonMode = ' text-mode';
                refreshButtonContent = <span>{storeState.cancelIsOn ? cancelButtonTitle : refreshButtonTitle}</span>;
                break;

            case 'iconAndText':
                refreshButtonMode = ' icon-and-text-mode';
                refreshButtonContent = (
                    <React.Fragment>
                        <span
                            className={
                                'glyphicon glyphicon-refresh' + (storeState.cancelIsOn ? ' cancel-on' : ' cancel-off')
                            }
                        />
                        <span>{storeState.cancelIsOn ? cancelButtonTitle : refreshButtonTitle}</span>
                    </React.Fragment>
                );
                break;

            default:
                refreshButtonMode = ' icon-mode';
                refreshButtonContent = (
                    <span
                        className={
                            'glyphicon glyphicon-refresh' + (storeState.cancelIsOn ? ' cancel-on' : ' cancel-off')
                        }
                    />
                );
        }

        refreshButton = (
            <button
                type="button"
                className={
                    'refresh-button btn JEST-toolbar-button-refresh' +
                    (props.forNavigationBar ? '' : ' btn-default') +
                    refreshButtonMode +
                    buttonClass
                }
                title={storeState.cancelIsOn ? cancelButtonTooltip : refreshButtonTooltip}
                style={navigationBarButtonsStyle}
                onClick={handleOnRefreshButtonClick}
            >
                {refreshButtonContent}
            </button>
        );
    }

    let backButton: React.JSX.Element;

    if (props.showBackButton) {
        let backButtonContent: React.JSX.Element;
        let backButtonMode: string;

        switch (props.backButtonShowMode) {
            case 'text':
                backButtonMode = ' text-mode';
                backButtonContent = <span>{'Back'}</span>;
                break;

            case 'iconAndText':
                backButtonMode = ' icon-and-text-mode';
                backButtonContent = (
                    <React.Fragment>
                        <span className={'glyphicon glyphicon-arrow-left'} />
                        <span>{'Back'}</span>
                    </React.Fragment>
                );
                break;

            default:
                backButtonMode = ' icon-mode';
                backButtonContent = <span className={'glyphicon glyphicon-arrow-left'} />;
        }

        backButton = (
            <button
                type="button"
                className={'back-button btn JEST-toolbar-button-back' + backButtonMode + buttonClass}
                title={'Back'}
                style={navigationBarButtonsStyle}
                onClick={(e) => {
                    window.history.go(-1);
                }}
            >
                {backButtonContent}
            </button>
        );
    }

    let fullScreenButton: React.JSX.Element;

    if (props.showFullScreenButton) {
        let fullScreenContent: React.JSX.Element;
        let fullScreenMode: string;
        let icon = 'bi-fullscreen font-weight-bold';
        let text = 'Enter Full Screen';

        if (document.fullscreenElement) {
            icon = 'bi-fullscreen-exit font-weight-bold';
            text = 'Exit Full Screen';
        }

        switch (props.fullScreenButtonShowMode) {
            case 'text':
                fullScreenMode = ' text-mode';
                fullScreenContent = <span>{'Full Screen'}</span>;
                break;

            case 'iconAndText':
                fullScreenMode = ' icon-and-text-mode';
                fullScreenContent = (
                    <React.Fragment>
                        <span className={icon} />
                        <span>{text}</span>
                    </React.Fragment>
                );
                break;

            default:
                fullScreenMode = ' icon-mode';
                fullScreenContent = <span className={icon} />;
        }

        fullScreenButton = (
            <button
                type="button"
                className={'fullScreen-button btn JEST-toolbar-button-fullScreen' + fullScreenMode + buttonClass}
                title={text}
                style={navigationBarButtonsStyle}
                onClick={(e) => {
                    // element which needs to enter full-screen mode
                    e.stopPropagation();
                    e.preventDefault();
                    props.glob.AppActions.toggleFullScreenMode();
                }}
            >
                {fullScreenContent}
            </button>
        );
    }

    let content: React.JSX.Element;

    if (props.justifyButtons) {
        const cells: React.JSX.Element[] = [];

        if (addTabButton != null) {
            cells.push(<td key="addTabButton">{addTabButton}</td>);
        }

        if (resetButton != null) {
            cells.push(<td key="resetButton">{resetButton}</td>);
        }

        if (applyButton != null) {
            cells.push(<td key="applyButton">{applyButton}</td>);
        }

        if (refreshButton != null) {
            cells.push(<td key="refreshButton">{refreshButton}</td>);
        }

        if (backButton != null) {
            cells.push(<td key="backButton">{backButton}</td>);
        }

        if (fullScreenButton != null) {
            cells.push(<td key="fullScreenButton">{fullScreenButton}</td>);
        }

        if (cells.length > 0) {
            content = (
                <table className="table-borderless w-100">
                    <tbody>
                        <tr>{cells}</tr>
                    </tbody>
                </table>
            );
        }
    } else {
        content = (
            <>
                {addTabButton}
                {resetButton}
                {applyButton}
                {refreshButton}
                {backButton}
                {fullScreenButton}
            </>
        );
    }

    return <div className={'toolbar-buttons ' + (props.justifyButtons ? 'justfy' : 'btn-group')}>{content}</div>;
}

export function NavigationBar(props: {
    id: number;
    cid: number;
    tab: number;
    tabDisplay: number;
    tabs: ITab[];
    workspaceState: IWorkspaceState;
    layoutType: WorkspaceLayoutType;
    widgetMode: boolean;
    useTabsMode: boolean;
    pinNavigationBar: boolean;
    hidden: boolean;
    theme: IValuesCollection;
    glob: IGlob;

    logoToLeft: React.JSX.Element;
    logoToFullLeft: React.JSX.Element;
    logoAbove: React.JSX.Element;

    getTopActiveButtons(): React.JSX.Element;
    getCommandMenu(): React.JSX.Element;

    onWorkspacesNavSelect(id: number, mode: MenuModes): void;
    onToggleWorkspacesNavigationBar(): void;
    onWorkspaceRemove(id: number, tab: number, isNew: boolean, isSame: boolean): void;
    onManualWorkspaceUpdate(): void;
    onLayoutCarouselChange(widgetID: number): void;
    onNavAndLogoChange(navigationWidth: number): void;
    onTogglePinNavigationBar(): void;
}) {
    const { layoutType, theme, workspaceState, logoToLeft } = props;

    const getWorkspaceNavigatonMenu = () => {
        const result = [];
        const menuOrientation = props.glob.SettingsStore.getMenuOrientation();

        if (menuOrientation === 'Horizontal') {
            if (logoToLeft != null) {
                result.push(
                    <div className="nav-brand" key="nav-brand">
                        {logoToLeft}
                    </div>
                );
            }

            result.push(
                <WorkspacesNavigation
                    key="workspaces-navigation"
                    menuMode={MenuModes.horizontal}
                    id={workspaceState.instance.id + '-' + props.tab}
                    glob={props.glob}
                    onSelect={props.onWorkspacesNavSelect}
                    onShow={props.onNavAndLogoChange}
                />
            );
        } else {
            if (logoToLeft != null) {
                result.push(
                    <div className="nav-brand" key="nav-brand">
                        {logoToLeft}
                    </div>
                );
            }

            const showSideBar = permissions.showSideBar();

            if (showSideBar) {
                result.push(
                    <form className="form-inline" key="navbar-toggle-sidebar">
                        <div
                            className={
                                'btn border-0 navbar-color-pattern' +
                                (workspaceState.storeState.showSidebar ? ' active' : '')
                            }
                            key="toggle-sidebar"
                            style={{ boxShadow: 'none' }}
                            onClick={props.onToggleWorkspacesNavigationBar}
                        >
                            <span className="glyphicon glyphicon-align-justify"></span>
                            <span className="caret"></span>
                        </div>
                    </form>
                );
            }
        }

        return result;
    };

    const handleOnAddTabClick = () => {
        props.glob.AppActions.addTab();
    };

    const handleOnResetClick = () => {
        const id = props.id || props.cid;

        props.glob.AppActions.resetFilters(id, props.tab, '_default');
    };

    const handleOnApplyClick = () => {
        workspaceState.globalState.applyShelvedFilters(theme);
    };

    const getTopActiveButtons = () => {
        if (props.widgetMode !== true) {
            return (
                <div className="btn-group" role="group">
                    {props.getTopActiveButtons()}
                </div>
            );
        }

        return null;
    };

    const getTabsAndButtons = () => {
        const result = [];

        if (props.widgetMode !== true) {
            const { data } = workspaceState.instance;
            const isNew = props.id == null || props.id < 0;
            //const isNotSaved = data != null && state.originalData != null && serializeWorkspace(data) !== state.originalData;

            result.push(getWorkspaceNavigatonMenu());

            if (layoutType === 'normal') {
                const showSideBar = permissions.showSideBar();
                const justifyButtons = theme[themeVars.justifyButtons];
                const hideRefreshButton = theme[themeVars.showRefreshButton] === false;
                const showResetButton = theme[themeVars.showResetButton];
                const showApplyButton = theme[themeVars.showApplyButton];
                const resetButtonShowMode = theme[themeVars.resetButtonShowMode];
                const refreshButtonShowMode = theme[themeVars.refreshButtonShowMode];
                const showBackButton = theme[themeVars.showBackButton];
                const backButtonShowMode = theme[themeVars.backButtonShowMode];
                const showFullScreenButton = theme[themeVars.showFullScreenButton];
                const fullScreenButtonShowMode = theme[themeVars.fullScreenButtonShowMode];

                if (props.useTabsMode) {
                    result.push(
                        <WorkspaceTabMenu
                            key="workspace-tab-menu"
                            tabs={props.tabs}
                            tabDisplay={props.tabDisplay}
                            //editMode={ inEditMode() }
                            viewportWidth={workspaceState.viewportWidth}
                            navAndLogoWidth={workspaceState.navigationAndLogoWidth}
                            showActions={props.pinNavigationBar}
                            //isNotSaved={ isNotSaved }
                            workspaceIsNew={isNew}
                            theme={theme}
                            glob={props.glob}
                            onWorkspaceRemove={props.onWorkspaceRemove}
                        />
                    );
                }

                result.push(
                    <ToolbarButtons
                        key="toolbar-buttons"
                        theme={theme}
                        options={{
                            tab: props.tab,
                            workspace: props.id
                        }}
                        buttonClass={'border-0'}
                        justifyButtons={justifyButtons}
                        forNavigationBar={true}
                        showAddTabButton={props.useTabsMode && showSideBar}
                        hideResetButton={!showResetButton}
                        hideApplyButton={!showApplyButton}
                        hideRefreshButton={hideRefreshButton}
                        resetButtonShowMode={resetButtonShowMode}
                        refreshButtonShowMode={refreshButtonShowMode}
                        showBackButton={showBackButton}
                        backButtonShowMode={backButtonShowMode}
                        showFullScreenButton={showFullScreenButton}
                        fullScreenButtonShowMode={fullScreenButtonShowMode}
                        glob={props.glob}
                        onAddTabClick={handleOnAddTabClick}
                        onRefreshClick={props.onManualWorkspaceUpdate}
                        onResetClick={handleOnResetClick}
                        onApplyClick={handleOnApplyClick}
                    />
                );
            } else if (data != null && data.widgets != null && data.widgets.length > 1) {
                result.push(
                    <form className="form-inline" key="layout-carousel">
                        <LayoutCarouselNavigation
                            widgets={data.widgets}
                            currentWidgetId={workspaceState.layoutCarouselCurrentWidgetId}
                            viewportWidth={workspaceState.viewportWidth}
                            viewportHeight={workspaceState.viewportHeight}
                            onChange={props.onLayoutCarouselChange}
                        />
                    </form>
                );
            }

            result.push(
                <div className="d-flex justify-content-end flex-grow-1 flex-nowrap" key="toggle-navbar-command-menu">
                    {props.getCommandMenu()}
                </div>
            );
        }

        return result;
    };

    let mainRowStyle: React.CSSProperties;

    // Add border for non-active tabs.
    if (theme['navbar-material-style'] != true) {
        mainRowStyle = { borderBottom: '1px solid ' + theme['navbar-active-link-hover-border-color'] };
    }

    // Pop the active navbar, It is needed to make navbar of active workspace operational and hide navbar of inactive ones.
    const navBarStyle: React.CSSProperties = props.hidden ? { zIndex: 1 } : { zIndex: 2 };

    if (layoutType !== 'narrow') {
        navBarStyle.minWidth = '600px';
    }

    let logoToFullLeftRow: React.JSX.Element;

    if (props.logoToFullLeft != null) {
        logoToFullLeftRow = (
            <td className="full-left-logo-cell" rowSpan={2}>
                {props.logoToFullLeft}
            </td>
        );
    }

    return (
        <table className="navigation-bar table-borderless w-100 navbar-color-pattern">
            <tbody>
                <tr className="navigation-bar-top-row">
                    {logoToFullLeftRow}

                    <td className="top-logo-cell">{props.logoAbove}</td>

                    <td className="top-active-buttons-cell">{getTopActiveButtons()}</td>

                    <td className="pin-cell">
                        <PinNavigationBarButton
                            active={props.pinNavigationBar}
                            onClick={props.onTogglePinNavigationBar}
                        />
                    </td>
                </tr>
                <tr className="navigation-bar-main-row" style={mainRowStyle}>
                    <td colSpan={3}>
                        <div
                            className={
                                'navbar navbar-expand flex-nowrap pr-1 pb-1 ' +
                                (props.workspaceState.storeState.actionLoading ? ' loading' : '')
                            }
                            style={navBarStyle}
                        >
                            <div className="navbar-collapse flex-nowrap">{getTabsAndButtons()}</div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

function PinNavigationBarButton(props: { active: boolean; onClick(e): void }) {
    return (
        <div
            title={props.active ? 'Unpin Navigation Bar' : 'Pin Navigation Bar'}
            className={
                'pin-navigation-bar-button btn border-0 navbar-color-pattern bi ' +
                (props.active ? 'bi-pin-fill' : 'bi-pin-angle-fill')
            }
            onClick={props.onClick}
        />
    );
}

export function UserProfileButton(props: { buttonClass?: string; glob: IGlob }) {
    const getProfileWorkspace = () => {
        const myprofile = props.glob.SettingsStore.getAppSetting('workspace/myprofile');

        if (myprofile != null) {
            const selectedWorkspaces = _.keys(myprofile.workspace);

            if (selectedWorkspaces.length > 0) {
                return selectedWorkspaces[0];
            }
        }

        return null;
    };

    const profileWorkspace = getProfileWorkspace();

    if (profileWorkspace == null) {
        return null;
    }

    const handleOnProfileClick = () => {
        const profileWorkspace = getProfileWorkspace();

        if (profileWorkspace != null) {
            props.glob.mainRouter.navigate('workspaces/activate/' + profileWorkspace, {
                trigger: true
            });
        }
    };

    const authData = props.glob.AppStore.getAuthenticationData();

    return (
        <div
            title={'Profile and Preferences'}
            className={
                'user-icon btn border-0 navbar-color-pattern' +
                (props.buttonClass != null ? ' ' + props.buttonClass : '') +
                (authData.picture == null ? ' fa fa-user' : '')
            } //glyphicon glyphicon-user
            onClick={handleOnProfileClick}
        >
            {authData.picture != null ? (
                <img src={authData.picture} title={authData.displayName} className="user-profile-picture" />
            ) : (
                <span className="user-name-text">{authData.displayName}</span>
            )}
        </div>
    );
}

export function GuideButton(props: { buttonClass?: string; glob: IGlob }) {
    const getGuideWorkspace = () => {
        const guide = props.glob.SettingsStore.getAppSetting('workspace/documentation');

        if (guide != null) {
            const selectedWorkspaces = _.keys(guide.workspace);

            if (selectedWorkspaces.length > 0) {
                return selectedWorkspaces[0];
            }
        }

        return null;
    };

    const guideWorkspace = getGuideWorkspace();

    if (guideWorkspace == null) {
        return null;
    }

    const handleOnGuideClick = () => {
        const guideWorkspace = getGuideWorkspace();

        if (guideWorkspace != null) {
            props.glob.mainRouter.navigate('workspaces/activate/' + guideWorkspace, {
                trigger: true
            });
        }
    };

    return (
        <div
            title={'Documentation'}
            className={
                'guide-button btn border-0 navbar-color-pattern fa fa-question-circle' +
                (props.buttonClass != null ? ' ' + props.buttonClass : '')
            }
            onClick={handleOnGuideClick}
        />
    );
}
